<div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
  <div class="bg-overlay"></div>
  <div class="auth-page-content overflow-hidden pt-lg-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card overflow-hidden">
            <div class="row g-0">
              <div class="col-lg-6">
                <div class="p-lg-5 p-4 auth-one-bg h-100">
                  <div class="bg-overlay"></div>
                  <div class="position-relative h-100 d-flex flex-column">
                    <div class="mb-4">
                      <a routerLink="/" class="d-block">
                        <img src="assets/images/logo.png" alt="" height="60">
                      </a>
                    </div>
                    <div class="mt-auto">
                      <div class="mb-3">
                        <i class="ri-double-quotes-l display-4 text-light"></i>
                      </div>

                      <div id="qoutescarouselIndicators" class="carousel slide" data-bs-ride="carousel">
                        <div class="carousel-indicators">
                          <button type="button" data-bs-target="#qoutescarouselIndicators" data-bs-slide-to="0"
                            class="active" aria-current="true" aria-label="Slide 1"></button>
                          <button type="button" data-bs-target="#qoutescarouselIndicators" data-bs-slide-to="1"
                            aria-label="Slide 2"></button>
                          <button type="button" data-bs-target="#qoutescarouselIndicators" data-bs-slide-to="2"
                            aria-label="Slide 3"></button>
                        </div>
                        <div class="carousel-inner text-center text-white pb-5">
                          <div class="carousel-item active">
                            <p class="fs-15 fst-italic">" Une gestion fluide des files d’attente pour un meilleur
                              confort des clients. "</p>
                          </div>
                          <div class="carousel-item">
                            <p class="fs-15 fst-italic">" Optimisez votre accueil et réduisez le temps d’attente grâce à
                              notre solution. "</p>
                          </div>
                          <div class="carousel-item">
                            <p class="fs-15 fst-italic">" Un système simple, rapide et efficace pour organiser vos files
                              d’attente. "</p>
                          </div>
                          <div class="carousel-item">
                            <p class="fs-15 fst-italic">" Offrez une meilleure expérience à vos visiteurs grâce à une
                              gestion intelligente. "</p>
                          </div>
                          <div class="carousel-item">
                            <p class="fs-15 fst-italic">" Modernisez votre service d’accueil avec une file d’attente
                              digitale et connectée. "</p>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="p-lg-5 p-4">
                  <div>
                    <h5 class="text-primary">Créer un nouveau mot de passe</h5>
                    <p class="text-muted">Votre nouveau mot de passe doit être différent du mot de passe utilisé
                      précédemment.</p>
                  </div>

                  <div class="mt-4">
                    <form novalidate [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">

                      <div class="mb-3">
                        <label class="form-label" for="password">Mot de passe</label>
                        <div class="position-relative auth-pass-inputgroup mb-3">
                          <input #password id="password" class="form-control pe-5 password-input"
                            placeholder="Entrez le mot de passe" formControlName="password" type="password"
                            [ngClass]="{ 'is-invalid': submitted && f['password'].errors }">
                          <button (click)="togglePassword(password)"
                            class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                            type="button" id="password-addon"><i
                              [ngClass]="{ 'ri-eye-off-fill': showPassword, 'ri-eye-fill ': !showPassword }"
                              class="align-middle"></i></button>
                          <div *ngIf="submitted && f['password'].errors" class="invalid-feedback form-text">
                            <div *ngIf="f['password'].errors['required']"> Le mot de passe est obligatoire </div>
                            <div *ngIf="f['password'].errors['pattern']"> Le mot de passe doit contenir aumoin une
                              majuscule, une minuscule, un chiffre et un caractère special </div>
                            <div *ngIf="f['password'].errors['minlength']"> Le mot de passe doit contenir au moins 8
                              caractères </div>
                          </div>
                        </div>
                      </div>

                      <div class="mb-3">
                        <label class="form-label" for="confirmPassword">Confirmez le mot de passe</label>
                        <div class="position-relative auth-pass-inputgroup mb-3">
                          <input #confirmPassword id="confirmPassword" class="form-control pe-5 password-input"
                            placeholder="Confirmez le mot de passe" formControlName="confirmPassword" type="password"
                            [ngClass]="{ 'is-invalid': submitted && f['confirmPassword'].errors }">
                          <button (click)="togglePassword(confirmPassword)"
                            class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                            type="button" id="password-addon"><i
                              [ngClass]="{ 'ri-eye-off-fill': showPassword, 'ri-eye-fill ': !showPassword }"
                              class="align-middle"></i></button>
                          <div *ngIf="submitted && f['confirmPassword'].errors" class="invalid-feedback form-text">
                            <div *ngIf="f['confirmPassword'].errors['required']"> La confirmation du mot de passe est
                              obligatoire </div>
                            <div *ngIf="f['confirmPassword'].errors['mustMatch']"> Le mot de passe ne correspond pas
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mt-4">
                        <button class="btn btn-primary w-100 " type="submit">
                          {{loading? 'Veuillez patienter ' : 'Réinitialiser le mot de passe' }}
                          <span class="{{ loading? 'spinner-border spinner-border-sm ms-2' : '' }}" role="status">
                          </span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center">
            <p class="mb-0">&copy;
              <script>document.write(new Date().getFullYear())</script> SappTradingPro. Crafted with <i
                class="mdi mdi-heart text-danger"></i> by <a href="#" target="_blank" class="text-reset">SA</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
